import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const convertToDataTable = (data: IGetPendingStatus[]): IGetPendingStatus[] => {
  const dataTableData: IGetPendingStatus[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllPendingStatusList = async (): Promise<IGetPendingStatus[]> => {
  const response =  await axiosDefaultApi.get(`/api/PendingStatus/GetPendingStatus`);
  return convertToDataTable(response as unknown as IGetPendingStatus[]);
};

type QueryFnType = typeof getAllPendingStatusList;

type UseGetAllPendingStatusListOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllPendingStatusList = ({ config }: UseGetAllPendingStatusListOptions = {} ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllPendingStatusList'],
    queryFn: () => getAllPendingStatusList(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};